import Vue from "vue";
import Router from "vue-router";
import Home from "./components/Home.vue";
import Lijst from "./components/geboortelijst.vue";
import firebase from "firebase/app";
import "firebase/auth"

Vue.use(Router);

let router = new Router({
  mode: "history", // history mode gets errors on gitlab pages
  base: process.env.BASE_URL,
  routes: [
    { path: "*", redirect: "/" },
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/geboortelijst",
      name: "geboortelijst",
      component: () => import(/* webpackChunkName: 'lijst'*/ "./components/geboortelijst.vue")
    },
    {
      path: "/nieuw",
      name: "nieuw",
      component: () => import(/* webpackChunkName: 'admin'*/ "./components/nieuw.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/edit/:id",
      name: "edit",
      component: () => import(/* webpackChunkName: 'admin'*/ "./components/nieuw.vue"),
      props: true
    },
    {
      path: "/detail/:id",
      name: "detail",
      component: () => import(/* webpackChunkName: 'lijst'*/ "./components/detail.vue"),
      props: true
    },
    {
      path: "/checkout",
      name: "checkout",
      component: () => import(/* webpackChunkName: 'buyer'*/ "./components/checkout.vue")
    },
    {
      path: "/after",
      name: "thanks",
      component: () => import(/* webpackChunkName: 'buyer'*/ "./components/thanks.vue")
    },
    {
      path: "/reserveringen",
      name: "reserveringen",
      component: () => import(/* webpackChunkName: 'admin'*/ "./components/reserveringen.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/login",
      name: "login",
      component: () => import(/* webpackChunkName: 'admin'*/ "./components/login.vue")
    },
    {
      path: "/contact",
      name: "contact",
      component: () => import(/* webpackChunkName: 'contact'*/ "./components/contact.vue")
    },
    {
      path: "/homeEditor",
      name: "homeEditor",
      component: () => import(/* webpackChunkName: 'admin'*/ "./components/homeEditor.vue"),
      meta: { requiresAuth: true }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach((to, from, next) => {
  try {
    const currentUser = firebase.auth().currentUser;
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

    if (requiresAuth && !currentUser) {
      next("login");
    } else {
      next();
    }
  } catch (err) {
    console.error(JSON.stringify(err));
  }
});

export default router;
